export default __webpack_public_path__ + "static/media/surveyMd.f4d3569e.png";